<template>
  <div class="approveBox">
    <qx-card title="核销">
      <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" />
      <SubBtnBox @sub="sub" :customCancel="customCancel" @cancel="cancel" />
    </qx-card>
    <!-- <qx-card title="审核日志" v-show="tableData.data.length > 0">
      <div class="tableBox">
        <el-table
          :data="tableData.data"
          tooltip-effect="dark"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :min-width="item.minW"
            :width="item.w"
          />
        </el-table>
      </div>
    </qx-card> -->
  </div>
</template>

<script>
import SubBtnBox from 'components/subBtnBox';
import {
  verificationOaLoanCar,
} from 'api/cost';
export default {
  components: {
    SubBtnBox,
  },
  props: {
    busiId: {
      type: String,
    },
    otherParams: {
      type: Object,
      default: () => ({}),
    },
    customPost: {
      type: Boolean,
      default: false,
    },
    customCancel: {
      type: Boolean,
      default: false,
    },
    costomSuccess: {
      type: Boolean,
      default: false,
    },
  },
  // watch: {
  //   otherParams: {
  //     // immediate: true,
  //     handler (newValue, oldValue) {
  //       if (newValue) {
  //         console.log(newValue, oldValue);
  //       }
  //     },
  //     deep: true,
  //   },
  // },
  data () {
    return {
      baseForm: {
        form: [
          {
            value: 'cashAmount',
            label: '退还现金',
            type: 'input',
          },
          // {
          //   value: 'billAmount',
          //   label: '票据核销金额',
          //   type: 'input',
          // },
          {
            value: 'attachment',
            label: '附件',
            type: 'img',
            accept: 'image/*',
            default: [],
          },
          {
            value: 'verifyRemark',
            label: '核销备注',
            type: 'input',
            width: '430px',
            attr: {
              type: 'textarea',
              limit: 300,
            },
          },
        ],
        rules: {
          attachment: [
            { required: true, message: '请上传付款凭证', trigger: 'blur' },
          ],
          verifyRemark: [
            { required: true, message: '请输入核销备注', trigger: 'blur' },
          ],
        },
      },
      // tableData: {
      //   title: [
      //   ],
      //   data: [],
      // },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (this.customPost) {
        this.$emit('sub', formData);
        return;
      }
      if (formData) {
        let fileId = [];
        if (formData.attachment && formData.attachment.length) {
          for (let item of formData.attachment) {
            fileId.push(item.id);
          }
        }
        delete this.otherParams.sysOperLogs;
        const params = {
          ...this.otherParams,
          ...formData,
          fileId: fileId.join(','),
        };
        delete params.attachment;
        delete params.attachment;
        delete params.fileId;
        delete params.fileIdV;
        delete params.fileName;
        delete params.fileNameV;
        delete params.fileUrl;
        delete params.fileUrlV;
        delete params.sysOperLogs;
        let res = await verificationOaLoanCar(params);
        if (!res.failed && !this.costomSuccess) {
          this.$message({
            type: 'success',
            message: '保存成功',
          });
          this.close();
        } else if (!res.failed) {
          this.$emit('success');
        }
      }
    },
    cancel () {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped lang="scss">
.approveBox {
  padding-bottom: 56px;
}
</style>
